import axios from 'axios';

const API_URL = 'https://fifty-two-in-the-lou-production.up.railway.app/api';

const login = async (username, password) => {
  const response = await axios.post(`${API_URL}/auth/login`, { username, password });
  if (response.data.token) {
    sessionStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

const register = async (firstName, lastName, username, email, password) => {
  const response = await axios.post(`${API_URL}/auth/register`, {
    firstName, lastName, username, email, password
  });
  if (response.data.token) {
    sessionStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

const logout = () => {
  sessionStorage.removeItem('user');
};

const getCurrentUser = () => {
  return JSON.parse(sessionStorage.getItem('user'));
};

const authService = { login, register, logout, getCurrentUser };
export default authService;